import { Alert, AlertTitle, Box, Button, List, ListItem, Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useCompanyBlocks } from "src/context/CompanyBlocksContext";
import SkeletonLoad from "src/pages/components/SkeletonLoad";

const CompanyBlockStatusTab: FC = () => {
  const { blockStatus, softBlockStatus, isLoading, refetch } = useCompanyBlocks();

  const hasBlocking = useMemo(
    () => Boolean(blockStatus?.is_blocked || softBlockStatus?.is_blocked),
    [blockStatus?.is_blocked, softBlockStatus?.is_blocked],
  );

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box>
        <Typography variant="h6">Em dia com a EezyCare</Typography>
        <Typography variant="body2" color="text.secondary">
          Consulte rapidamente a situação de bloqueios e pendências da sua empresa.
        </Typography>
      </Box>

      <Alert severity={hasBlocking ? "warning" : "success"}>
        <AlertTitle>{hasBlocking ? "Encontramos bloqueios ativos" : "Tudo certo por aqui"}</AlertTitle>
        {hasBlocking
          ? "Regularize os bloqueios abaixo para liberar todas as funcionalidades da plataforma."
          : "Sua empresa está em dia e todas as funcionalidades estão liberadas."}
      </Alert>

      {isLoading ? (
        <SkeletonLoad variant="cards" rows={2} />
      ) : (
        <Stack spacing={2}>
          {blockStatus?.is_blocked && (
            <Alert severity="error">
              <AlertTitle>{blockStatus?.status_message?.title ?? "Bloqueio total"}</AlertTitle>
              <Typography variant="body2" marginBottom={1}>
                {blockStatus?.status_message?.description ??
                  "Esta empresa está temporariamente impedida de registrar novos atendimentos."}
              </Typography>
              {blockStatus?.restricted_actions?.length ? (
                <Box>
                  <Typography variant="subtitle2">Ações restritas:</Typography>
                  <List dense>
                    {blockStatus.restricted_actions.map((action) => (
                      <ListItem key={action} sx={{ paddingY: 0 }}>
                        <Typography variant="body2">• {action}</Typography>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              ) : null}
              {blockStatus?.internal_message && (
                <Typography variant="body2" color="text.secondary">
                  {blockStatus.internal_message}
                </Typography>
              )}
            </Alert>
          )}

          {softBlockStatus?.is_blocked && (
            <Alert severity="warning">
              <AlertTitle>{softBlockStatus?.status_message?.title ?? "Bloqueio parcial"}</AlertTitle>
              <Typography variant="body2">
                {softBlockStatus?.status_message?.description ??
                  "Algumas funcionalidades podem estar limitadas enquanto aguardamos regularização."}
              </Typography>
            </Alert>
          )}

          <Box>
            <Button variant="outlined" onClick={refetch}>
              Atualizar status
            </Button>
          </Box>
        </Stack>
      )}
    </Box>
  );
};

export default CompanyBlockStatusTab;
